module.exports = __webpack_public_path__ + "img/春节大促_36.7df4325f.png";